webpackJsonp([219701805261564],{

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactstrap = __webpack_require__(30);
	
	var _block = __webpack_require__(10);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _myTitle = __webpack_require__(12);
	
	var _myTitle2 = _interopRequireDefault(_myTitle);
	
	var _blockCover = __webpack_require__(17);
	
	var _blockCover2 = _interopRequireDefault(_blockCover);
	
	var _contact = __webpack_require__(57);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _data = __webpack_require__(45);
	
	var _data2 = _interopRequireDefault(_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Pour votre projet de cr\xE9ation en bois sur mesure, contactez nous'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'Nous relevons tous les challenges pour nous adapter \xE0 vos exigences et vos contraintes pour la fabrication de votre projet sur mesure.' })
	    ),
	    _react2.default.createElement(_blockCover2.default, {
	      backgroundUrl: _contact2.default,
	      title: 'Contact et Projet',
	      repeatedTitle: true }),
	    _react2.default.createElement(
	      _block2.default,
	      { hasDecoration: true, className: 'block-grey-background' },
	      _react2.default.createElement(
	        _myTitle2.default,
	        null,
	        'J\'ai un projet'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'light fs-16 lh-23 text-align-center mb-4' },
	        'Parlez-en avec nous :',
	        _react2.default.createElement('br', null),
	        'nous sommes l\xE0 pour le r\xE9aliser !'
	      ),
	      _react2.default.createElement(
	        _reactstrap.Form,
	        { method: 'post', 'data-netlify': 'true', 'data-netlify-honeypot': 'bot-field', name: 'projet', enctype: 'multipart/form-data' },
	        _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'projet' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'hidden' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Don\u2019t fill this out: ',
	            _react2.default.createElement('input', { name: 'bot-field' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-md-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-5' },
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              null,
	              _react2.default.createElement(_reactstrap.Input, { type: 'text', name: 'firstname', id: 'firstname', placeholder: 'Pr\xE9nom' })
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              null,
	              _react2.default.createElement(_reactstrap.Input, { type: 'text', name: 'lastname', id: 'lastname', placeholder: 'Nom' })
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              null,
	              _react2.default.createElement(_reactstrap.Input, { type: 'email', name: 'email', id: 'email', placeholder: 'Adresse email' })
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              null,
	              _react2.default.createElement(_reactstrap.Input, { type: 'phone', name: 'phone', id: 'phone', placeholder: 'T\xE9l\xE9phone' })
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Input,
	                { type: 'select', name: 'project', id: 'project' },
	                _react2.default.createElement(
	                  'option',
	                  { disabled: true, selected: true },
	                  'Projet'
	                ),
	                _data2.default.default.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'option',
	                    { key: index, value: item.title },
	                    item.title
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              null,
	              _react2.default.createElement(
	                _reactstrap.InputGroup,
	                null,
	                _react2.default.createElement(_reactstrap.Input, { placeholder: 'Zone g\xE9ographique du chantier', type: 'text' }),
	                _react2.default.createElement(
	                  _reactstrap.InputGroupAddon,
	                  null,
	                  _react2.default.createElement('img', { src: '/locate.svg', alt: 'Localisation' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              { row: true },
	              _react2.default.createElement(
	                _reactstrap.Label,
	                { 'for': 'date', sm: 6 },
	                'Date estim\xE9e du projet :'
	              ),
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(_reactstrap.Input, { type: 'date', name: 'date', id: 'date', placeholder: 'JJ/MM/AAAA' })
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              { row: true },
	              _react2.default.createElement(
	                _reactstrap.Label,
	                { 'for': 'file', sm: 12 },
	                'Envoi de plan, sch\xE9ma, croquis ou photo en t\xE9l\xE9chargement :'
	              ),
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { sm: 12 },
	                _react2.default.createElement(_reactstrap.Input, { type: 'file', name: 'file', id: 'file' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-align-center' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-primary btn-big btn-min-width-300 mt-3' },
	                'Envoyer'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'color-grey fs-12 light mt-3 text-align-center' },
	              '* D\xE9lai de r\xE9ponse sous 72h'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projet-js-7b159a62b3265063155a.js